module.exports = __webpack_public_path__ + "img/banner3.e1f80678.png";